import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { AppName } from "../../../../util/app";
import Select from "react-dropdown-select";
import DatePicker from "react-datepicker";
import Docs from "./docs.json";
import FileUpload from "../../../../util/FileUpload";

const NewPatientDischarge = ({ onSend }) => {
    const [model, setModel] = useState({
        date: new Date(),
        locationType: "",
        securityLevel: "",
        type: "",
        endOfLife: false,
        homeForLife: false,
        comment: "",
        service: "",
        status: "",
        external: {},
        documents: [],
        summary: [],
        checklistDocument: "",
    });
    const [confirmed, setConfirmed] = useState(false);

    const title = "New Patient Discharge";

    const init = () => {
        const _model = { ...model };
        _model.summary.push({ date: new Date(), comment: "", title: "Documents Sent To:(Names and Roles)", selected: false });
        _model.summary.push({ date: new Date(), comment: "", title: "Documents Sent To:GP:", selected: false });

        for (let index = 0; index < Docs.length; index++) {
            _model.documents.push({ date: new Date(), comment: "", title: Docs[index], selected: false });
        }
        // update local state
        setModel(_model);
    };

    const onSummarySelect = (title, date, comment) => {
        let found = false;
        const _model = { ...model };
        for (let index = 0; index < _model.summary.length; index++) {
            if (_model.summary[index].title === title) {
                found = true;
                const selected = document.getElementById(title).checked;
                _model.summary[index].selected = selected;
                if (date) _model.summary[index].date = date;
                if (comment) _model.summary[index].comment = comment;
                break;
            }
        }
        if (!found) {
            _model.summary.push({ title, date: date || new Date(), comment });
        }
        // Update state
        setModel(_model);
    };

    const onDocumentSelect = (title, date, comment) => {
        let found = false;
        const _model = { ...model };
        for (let index = 0; index < _model.documents.length; index++) {
            if (_model.documents[index].title === title) {
                found = true;
                const selected = document.getElementById(title).checked;
                _model.documents[index].selected = selected;
                if (date) _model.documents[index].date = date;
                if (comment) _model.documents[index].comment = comment;
                break;
            }
        }
        if (!found) {
            _model.documents.push({ title, date: date || new Date(), comment });
        }
        // Update state
        setModel(_model);
    };

    useEffect(() => {
        if (model.documents.length !== Docs.length) {
            init();
        }
    });
    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>
            <form
                onSubmit={(evt) => {
                    evt.preventDefault();

                    let _model = { ...model };
                    _model.documents = model.documents.filter((item) => item.selected).map((i) => ({ title: i.title, comment: i.comment, date: i.date }));
                    _model.summary = model.summary.filter((item) => item.selected).map((i) => ({ title: i.title, comment: i.comment, date: i.date }));
                    onSend({ _model, confirmed });
                }}
            >
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Form Detail</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Planning Status</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <Select
                                            onChange={(items) => setModel({ ...model, status: items[0].value })}
                                            options={[{ value: "Estimated" }, { value: "Scheduled " }, { value: "Delayed" }, { value: "Discharged " }, { value: "Transferred" }]}
                                            valueField="value"
                                            labelField="value"
                                            separator
                                            placeholder="-- Please Select --"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Scheduling</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Scheduling Date</strong>
                                </td>
                                <td>
                                    <div className="col-8">
                                        <DatePicker selected={model.date} onChange={(date) => setModel({ ...model, date })} className="form-control input-height" dateFormat="MMMM d, yyyy" />
                                    </div>
                                </td>
                                <td style={{ width: "20%" }}>
                                    <div className="custom-control custom-checkbox">
                                        <input onChange={({ currentTarget }) => setModel({ ...model, endOfLife: currentTarget.checked })} type="checkbox" className="custom-control-input" id="end" />
                                        <label className="custom-control-label" htmlFor="end">
                                            End of Life
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            onChange={({ currentTarget }) => setModel({ ...model, homeForLife: currentTarget.checked })}
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="home"
                                        />
                                        <label className="custom-control-label" htmlFor="home">
                                            Home for life
                                        </label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge Type*</strong>
                                </td>
                                <td colSpan="3">
                                    <div className="col-8">
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input onChange={() => setModel({ ...model, type: "Internal" })} type="radio" id="internal" className="custom-control-input" name="type" />
                                            <label className="custom-control-label" htmlFor="internal">
                                                Internal Transfer
                                            </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-inline">
                                            <input onChange={() => setModel({ ...model, type: "External" })} type="radio" name="type" className="custom-control-input" id="External" />
                                            <label className="custom-control-label" htmlFor="External">
                                                External Transfer
                                            </label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Comment*</strong>
                                </td>
                                <td colSpan="3">
                                    <div className="col-12">
                                        <textarea
                                            name="comment-id"
                                            id="comment-id"
                                            className="form-control form-control-textarea"
                                            required
                                            rows="3"
                                            onChange={({ currentTarget }) => {
                                                const { value } = currentTarget;
                                                setModel({ ...model, comment: value });
                                            }}
                                            placeholder="enter comment.."
                                        ></textarea>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Internal Discharge</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Select Service</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget: { value } }) =>
                                                setModel({
                                                    ...model,
                                                    service: value,
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter service"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>External Discharge</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td colSpan="2" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address of Discharge Location:</strong>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 1*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        address1: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter address"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 2</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        address2: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter address"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Address Line 3</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        address3: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            placeholder="enter address"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>City*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        city: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter city"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Country*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        country: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter country"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Postcode*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        postcode: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter postcode"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Telephone Number*</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget }) =>
                                                setModel({
                                                    ...model,
                                                    external: {
                                                        ...model.external,
                                                        mobile: currentTarget.value,
                                                    },
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter mobile"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Location Details</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Location Type:</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget: { value } }) =>
                                                setModel({
                                                    ...model,
                                                    locationType: value,
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter location type"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="text-right" style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Level of Security:</strong>
                                </td>
                                <td>
                                    <div className="col-6">
                                        <input
                                            onChange={({ currentTarget: { value } }) =>
                                                setModel({
                                                    ...model,
                                                    securityLevel: value,
                                                })
                                            }
                                            type="text"
                                            className="form-control input-height"
                                            required
                                            placeholder="enter security level"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-3 bg-primary text-center">
                        <h5>Discharge Documents</h5>
                    </div>

                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge checklist Documents</strong>
                                </td>
                                <td colSpan="5">
                                    <FileUpload
                                        title=""
                                        className="w-100"
                                        onData={(item) => {
                                            setModel({ ...model, checklistDocument: item.path });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                    <strong>Discharge Summary</strong>
                                </td>
                                <td colSpan="5">
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="Documents Sent To:(Names and Roles)" />
                                                        <label className="custom-control-label" htmlFor="Documents Sent To:(Names and Roles)">
                                                            Tick
                                                        </label>
                                                    </div>
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong>
                                                        Documents Sent To: <br />
                                                        (Names and Roles)
                                                    </strong>
                                                </td>
                                                <td>
                                                    <input
                                                        onChange={({ currentTarget }) => onSummarySelect("Documents Sent To:(Names and Roles)", null, currentTarget.value)}
                                                        type="text"
                                                        className="form-control input-height"
                                                        required
                                                    />
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong className="text-primary">Documents Sent On:</strong>
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        onChange={(date) => onSummarySelect("Documents Sent To:(Names and Roles)", date, null)}
                                                        selected={model.summary.length && model.summary[0].date}
                                                        className="form-control"
                                                        dateFormat="MMMM dd, YYY"
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="Documents Sent To:GP:" />
                                                        <label className="custom-control-label" htmlFor="Documents Sent To:GP:">
                                                            Tick
                                                        </label>
                                                    </div>
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong>
                                                        Documents Sent To: <br />
                                                        GP:
                                                    </strong>
                                                </td>
                                                <td>
                                                    <input
                                                        onChange={({ currentTarget }) => onSummarySelect("Documents Sent To:GP:", null, currentTarget.value)}
                                                        type="text"
                                                        className="form-control input-height"
                                                        required
                                                    />
                                                </td>
                                                <td style={{ backgroundColor: "aliceblue" }}>
                                                    <strong className="text-primary">Documents Sent On:</strong>
                                                </td>
                                                <td>
                                                    <DatePicker
                                                        onChange={(date) => onSummarySelect("Documents Sent To:GP:", date, null)}
                                                        selected={model.summary.length && model.summary[1].date}
                                                        className="form-control"
                                                        dateFormat="MMMM dd, YYY"
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            {Docs.map((doc, index) => (
                                <tr key={doc}>
                                    <td style={{ backgroundColor: "aliceblue", width: "20%" }}>
                                        <strong>{doc}</strong>
                                    </td>
                                    <td style={{ width: "5%" }}>
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" className="custom-control-input" id={doc} />
                                            <label className="custom-control-label" htmlFor={doc}>
                                                Tick
                                            </label>
                                        </div>
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                        <strong>
                                            Documents Sent To: <br />
                                            (Names and Roles)
                                        </strong>
                                    </td>
                                    <td>
                                        <input onChange={({ currentTarget }) => onDocumentSelect(doc, null, currentTarget.value)} type="text" className="form-control input-height" required />
                                    </td>
                                    <td style={{ backgroundColor: "aliceblue", width: "15%" }}>
                                        <strong className="text-primary">Documents Sent On:</strong>
                                    </td>
                                    <td style={{ width: "15%" }}>
                                        <DatePicker
                                            selected={model.documents.length && model.documents[index].date}
                                            onChange={(date) => onDocumentSelect(doc, date, null)}
                                            popperPlacement="left"
                                            className="form-control"
                                            dateFormat="MMMM dd, YYY"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="custom-control custom-checkbox">
                            <input defaultChecked={confirmed} type="checkbox" onChange={({ currentTarget: { checked } }) => setConfirmed(checked)} className="custom-control-input" id="confirm" />
                            <label className="custom-control-label" htmlFor="confirm">
                                Confirm upon saving
                            </label>
                        </div>
                    </div>
                    <div className="col-12 text-center m-t-20">
                        <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-primary">
                            Submit <i className="material-icons">keyboard_arrow_down</i>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};

export default NewPatientDischarge;
